import { FirestoreRequest } from '../../utils/firestore-data-source';

export const PERM_VIEW_ADMIN_ACTIVITY = 'view_admin_activity'

export interface ActivityListRequest extends FirestoreRequest {
  // filter
  userIds?: string[]
  types?: string[]
}
